import React from 'react'
import { FormProvider } from 'react-hook-form'
import { Button, Form } from 'reactstrap'
import FormBase from '../form-base'

const EndCustomerFilter = () => {
  return (
    <FormProvider>
        <Form>
            <FormBase />
            <Button color="primary" type="submit">
              Buscar
            </Button>
        </Form>
    </FormProvider>
  )
}

export default EndCustomerFilter